import * as $ from 'jquery';
import * as moment from 'moment';
import * as angular from 'angular';
import * as _ from 'lodash';

import {
  Input,
  OnInit,
  Component,
} from 'ng-metadata/core';

import { SearchComponent } from '../search.component';
import { SearchService } from 'services/search.service';

import searchVisasHtml from './search-visas.html';
import { PopulateService } from 'services/populate.service';
import { parseDomain } from 'helpers/parseDomain';

/**
 * Search Component class
 */
@Component({
  selector: 'gwSearchVisas',
  template: searchVisasHtml,
})
export class SearchVisasComponent extends SearchComponent implements OnInit {
  error: boolean = false;
  domain: string;
  travelersOpen: boolean;

  /**
   * Component init
   */
  ngOnInit() {
    const parsed = parseDomain(window.location.href);
    this.domain = parsed.domain;
    this.search.type = 'visas';

    const citizenshipList = this.setTopOptions(angular.copy(this.GW.countries),
                                               ['US', 'IN', 'GB', 'CA', 'AU', 'CN']);
    const destinationList = this.setTopOptions(angular.copy(this.GW.countries),
                                               ['CN', 'RU', 'IN', 'TR', 'AU', 'EG', 'KE', 'VN']);
    const residencyList = Object.keys(this.GW.states).map((key) => {
      return {
        id: key,
        value: key,
        label: this.GW.states[key],
      };
    });

    this.searchResults = {
      citizenship: {
        open: false,
        selected: this.searchValue || null,
        selectedCountryIndex: -1,
        focused: false,
        all: citizenshipList,
        items: citizenshipList,
      },
      destination: {
        open: false,
        selected: this.searchValue || null,
        selectedCountryIndex: -1,
        focused: false,
        all: destinationList,
        items: destinationList,
      },
      residency: {
        open: false,
        selected: this.searchValue || null,
        selectedCountryIndex: -1,
        focused: false,
        all: residencyList,
        items: residencyList,
      },
    };

    this.setDefaultResidency();
  }

  /**
   * Base component init
   */
  onInit() {
    // Fetch saved search from set cookie if it exists
    this.search = this.searchService.getSearch(this.searchClean);

    // Insert new destination row if none
    if (this.search.rows.length === 0) {
      this.searchService.addSearchRow();
    }

    // Get term set through binding if any
    if (this.searchTerm) {
      this.search.rows[0].term = this.searchTerm;
      this.search.rows[0].selected = this.searchValue;
    }

    // listen to dropdown close event
    this.$rootScope.$on('gw-close-drop', (e, data) => {
      this.search.rows[0].params.destination.open = false;
      this.search.rows[0].params.citizenship.open = false;
      this.search.rows[0].params.residency.open = false;
      this.onShow(false);
    });

    this.$rootScope.$on('gw-drop-closed', (e, data) => {
      this.clearInvalidSearchKeys(data.name);
    });
  }

  /**
   *  Keyboard navigation for country dropdown.
   */
  navigateCountryDropdown($event, param) {
    let index;
    const page = 6;

    $event.stopPropagation();

    switch ($event.key){
      case 'ArrowUp':
        index = this.searchResults[param].selectedCountryIndex;
        index = index > 0 ? index - 1 : index;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'PageUp':
        index = this.searchResults[param].selectedCountryIndex;
        index = index > page ? index - page : index;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'ArrowDown':
        index = this.searchResults[param].selectedCountryIndex;
        index = index < this.searchResults[param].items.length - 1 ? index + 1 : index;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'PageDown':
        index = this.searchResults[param].selectedCountryIndex;
        index = index < this.searchResults[param].items.length - page ? index + page : index;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'Enter':
        if (this.searchResults[param].items.length === 1) {
          this.selectResult(this.search.rows[0], this.searchResults[param].items[0], param);
        } else {
          this.$timeout(
            () => {
              angular.element('gw-drop-content ul.gw-search-results li.selected').trigger('click');
            });
        }
        break;

      case 'Home':
        index = 0;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'End':
        index = this.searchResults[param].items.length - 1;
        this.searchResults[param].selectedCountryIndex = index;
        this.scrollItem(index);
        break;

      case 'Escape':
        this.$rootScope.$emit('gw-close-drop');
        break;
    }
  }

  scrollItem(index) {
    const item = <HTMLElement>(
      document.querySelectorAll('gw-drop-content ul.gw-search-results li')[index]
    );
    item.scrollIntoView({ behavior: 'auto', block: 'end', inline: 'nearest' });
  }

  /**
   * Add destination row to search
   */
  addSearchRow() {
    this.searchService.addSearchRow();
  }

  /**
   * Remove a destination search row
   */
  removeSearchRow(search) {
    this.searchService.removeSearchRow(search);
  }

  addTraveler(type: string) {
    if (this.search.travelers[type] < 9) {
      this.search.travelers[type] += 1;
    }
  }

  removeTraveler(type: string) {
    const limit = 0;

    if (this.search.travelers[type] > limit) {
      this.search.travelers[type] -= 1;
    }
  }

  travelerTotal(): number {
    return this.search.travelers.adults + this.search.travelers.children;
  }

  /**
   * Search validation before submission
   */
  submitSearch() {
    const validationError = this.validate(this.search.rows[0].params);

    if (validationError !== '') {
      if (this.domain !== 'rushmytravelvisa') {
        return this.dialogService.openAlert({
          title: 'Oops',
          text: validationError,
          close: 'Try Again',
        });
      }

      this.error = true
      return
    }

    this.searchService.updateSearch(this.search);

    // Redirect
    return this.determineRoute();
  }

  /**
   * Redirect the search result
   */
  determineRoute() {
    let route;
    if (this.searchRoute.length) {
      const searchParams = this.search.rows[0].params;
      const params: any = {
        citizenship: this.$filter('slugify')(searchParams.citizenship.label.replace(/[\[\]]/g, '')),
        destination: this.$filter('slugify')(searchParams.destination.label.replace(/[\[\]]/g, '')),
        residency: searchParams.residency.code.toLowerCase(),
      };

      route = this.laroute.route(this.searchRoute, params);
    } else {
      route = window.location.href;
    }

    return super.submitSearch(route);
  }

  /**
   * Search result selected handler
   * @param {Object} search
   * @param {Object} result
   * @param param
   */
  selectResult(search, result, param = null) {
    search.params[param].label = result.label;
    search.params[param].code = result.value;

    search.params.citizenship.open = false;
    search.params.destination.open = false;
    search.params.residency.open = false;
    this.onShow(false);

    // Output to hero that the country changed
    if (param === 'destination') {
      this.$scope.$emit('search-change', {
        result: {
          type: search.type,
          value: search.params.destination.code,
        },
      });
    }
  }

  /**
   * Fetch results per parameter
   */
  fetchResults(search, param = null) {
    this.searchResults[param].selectedCountryIndex = -1;
    // Cleans the value of the selected country after user types a different country name.
    search.params[param].selected = '';

    if (!search.params[param].search) {
      this.searchResults[param].items = this.searchResults[param].all;
      this.searchResults[param].code = '';
      return;
    }

    search.params[param].search = search.params[param].search.replace(/  +/g, ' ');
    const items = this
      .$filter('filter')(this.searchResults[param].all, {
        label: search.params[param].search }, (actual, expected) => {
          return _.startsWith(actual.toLowerCase(), expected.toLowerCase());
        });

    if (items.length > 0) {
      this.searchResults[param].items = items;
    } else {
      search.params[param].search = search.params[param].search.slice(0, -1);
    }

    search.params[param].open = true;
  }

  /**
   * Change the list order to set top destinations
   *
   * @param items
   * @param top
   */
  setTopOptions(items, top) {
    const topItems = [];
    let pos;

    if (top === []) {
      return items;
    }

    // move to top
    top.forEach((topItem) => {
      pos = _.findIndex(items, item => item.value === topItem);
      if (pos !== -1) {
        topItems.push(items[pos]);
        items.splice(pos, 1);
      }
    });

    return _.union(topItems, items);
  }

  /**
   * Open a dropdown an close the others
   *
   * @param name
   */
  openDropdown(name) {
    for (const i in this.search.rows[0].params) {
      if (this.search.rows[0].params[i].open) {
        this.clearInvalidSearchKeys(i);
      }
      this.search.rows[0].params[i].open = i === name;
    }

    // reset the dropdown
    this.searchResults[name].items = this.searchResults[name].all;
    this.search.rows[0].params[name].search = '';
    this.onShow(true);
  }

  /**
   * Validate the search params
   *
   * @param params
   */
  validate(params) {
    let exists;

    // required
    for (const property in params) {
      if (!params[property].label) {
        return `The ${property} field is required. Please select a valid one.`;
      }

      // exist
      exists = this.searchResults[property].all.find((obj) => {
        return obj.label === params[property].label && obj.value === params[property].code;
      });
      if (exists === undefined) {
        return `The ${property} value '${params[property].label}' is not selected correctly. Please, select it in the dropdown menu.`;
      }
    }

    // citizenship != destination
    if (params.citizenship.label === params.destination.label) {
      return 'Nationality and Destination countries can not be the same';
    }

    return '';
  }

  /**
   * To clear invalid search params
   * @param param
   */
  clearInvalidSearchKeys(param) {
    if (!this.searchResults.hasOwnProperty(param)) {
      return;
    }

    const exists = this.searchResults[param].all.find((obj) => {
      return obj.label === this.search.rows[0].params[param].label;
    });
    if (exists === undefined) {
      this.search.rows[0].term = null;
      this.search.rows[0].selected = null;
      this.search.rows[0].params[param] = {
        label: '',
        code: '',
      };
      this.fetchResults(this.search.rows[0], param);
    }
  }

  onShow(show: boolean) {
    if (this.$window.innerHeight > 850) {
      $('html, body')
        .css('overflow', show ? 'hidden' : 'auto');
    }
  }

  /**
   * Set the default residency by ip location
   */
  setDefaultResidency() {
    if (this.search.rows[0].params.residency.code === '') {
      this.populateService.getDefaultState()
        .then((response) => {
          // set the default state to NY if the user is outside US
          if (response['status'] !== 'success' || response['data']['country'] !== 'US') {
            response['data']['region_code'] = 'NY';
            response['data']['region'] = 'New York';
          }
          this.search.rows[0].params.residency.code = response['data']['region_code'];
          this.search.rows[0].params.residency.label = response['data']['region'];
          this.searchResults.residency.selected = response['region_code'];
        })
        .catch((error) => { console.log(error); });
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/search/visas/search-visas.component.ts